module.exports = new __parcel__URL__("incidents-task-two-illustration.d4c7054b.png").toString();